<template>
  <el-dialog key="facebookDialog" title="Create Instagram Channel" width="40%" :visible="showDialog" append-to-body>

    <div class="dialog-body">
      <div v-if="isLoading" class="loader">
        <social-icon class="fa fa-fw" :type="'Instagram'" />
      </div>
      <div class="loader-text" v-show="isLoading">
        Waiting for authorization.
        <i class="fa fa-spinner fa-pulse"></i>
      </div>

      <div v-if="instagramPages.length !== 0" class="instagram-pages">
        <p>Choose Page(s)</p>
        <div class="page-list">
          <el-checkbox-group v-model="selectedPages">
            <div v-for="page of instagramPages" :key="page.page_id">
              <el-checkbox :label="page.page_id">{{page.page_name}}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="showDialog = false" plain>Cancel</el-button>
      <el-button type="primary" :disabled="isSaving || !selectedPages.length" @click="handleSaveChannel" plain>
        Save
        <i v-if="isSaving" class="fa fa-spinner fa-pulse"></i>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import SocialIcon from '@/components/common/Icons/SocialIcon';
import * as channelTypes from '@/store/modules/channel/mutation-types';

export default {
  name: 'InstagramCreateDialog',

  components: {
    SocialIcon,
  },

  data: () => ({
    selectedPages: [],
    isLoading: false,
    isSaving: false,
  }),

  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    me: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState('channel', ['instagramPages']),

    showDialog: {
      get() {
        return this.isVisible;
      },

      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
  },

  methods: {
    /**
     * Start Facebook oAuth process in new window.
     */
    handleRequestInstagramAuth() {
      this.$store.dispatch('channel/addInstagramChannelAuth', this.me).then(canShowDialog => {
        this.showDialog = canShowDialog;
        this.isLoading = canShowDialog;
      });
    },

    /**
     * Add channels for all selected pages. Then close dialog.
     */
    handleSaveChannel() {
      this.isSaving = true;

      const promises = this.selectedPages.map(x =>
        this.$store.dispatch('channel/addInstagramPage', [this.me.id, x]),
      );

      return Promise.all(promises).then(() => {
        this.$emit('onInstagramChannelAdded');
        this.isLoading = false;
        this.showDialog = false;
      });
    },

    /**
     * Clean up intervals in case it's still polling
     * reset component state for next time
     */
    destroyState() {
      this.$store.commit(`channel/${channelTypes.POLL_INSTAGRAM_PAGES_STOP}`);
      this.$store.commit(`channel/${channelTypes.CLEAR_ADD_INSTAGRAM_CHANNEL_STATE}`);
    },
  },

  watch: {
    /**
     * Kick of Auth process when opening.
     * Destroy state for next time when closing.
     */
    showDialog(toShow) {
      if (toShow) {
        this.handleRequestInstagramAuth();
      } else {
        this.destroyState();
      }
    },

    /**
     * If facebookPages were fetched, stop polling
     */
    instagramPages() {
      if (this.instagramPages.length > 0) {
        this.isLoading = false;
        this.$store.commit(`channel/${channelTypes.POLL_INSTAGRAM_PAGES_STOP}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-list {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px;
}

.loader {
  text-align: center;
  font-size: 3em;
}

.loader-text {
  text-align: center;
  font-size: 1.25em;
}
</style>



// WEBPACK FOOTER //
// InstagramCreateDialog.vue?a18fcf40